import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { MessageEx } from '../../../classes/messageex';
import { MessageUtils } from '../../../classes/messageutils';
import { SharedHelpers } from '../../../classes/sharedhelpers';

/**
 * A file shared as a link from OneDrive (a CLOUDFILELINK message), drawn like a file attachment: the file's icon,
 * name and size, with where it lives in place of a download. Opens the share link in a new tab. A body that isn't a
 * valid OneDrive link shows the message's fallback text instead.
 */
@Component({
  selector: 'app-cloud-file-card',
  templateUrl: './cloud-file-card.component.html',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CloudFileCardComponent {
  item = input<MessageEx>();
  isMine = input<boolean>();
  currentTabIndex = input<string>();
  previewMode = input<boolean>(false);

  // OneDrive is the only provider so far - the card's wording names it
  link = computed(() => {
    const link = MessageUtils.getCloudFileLink(this.item());
    return link?.provider === 'onedrive' ? link : null;
  });
  size = computed(() => (this.link()?.size > 0 ? SharedHelpers.getFileSize(this.link().size) : ''));
}
